import axios, { AxiosRequestConfig } from 'axios';
import { API_BASE_URL } from 'src/constants';

export const axiosConfig: AxiosRequestConfig = { baseURL: API_BASE_URL };
const axiosApiClient = axios.create(axiosConfig);
export default axiosApiClient;
